"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOption = exports.StyledDatalist = exports.StyledDropdownPopup = exports.StyledValue = exports.StyledDropdown = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const main_1 = require("./../text-field/main");
const main_2 = require("./../popup/main");
const variants_1 = require("../../themes/variants");
exports.StyledDropdown = (0, styled_components_1.default)(main_1.TextField) `
  [data-testid="input"] {
    appearance: none;
    &::-webkit-calendar-picker-indicator {
      display: none !important;
    }
  }
  [data-testid="input-icon-right"] {
    cursor: pointer;
  }
  [data-testid="icon-value"] {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0.25rem;
    box-sizing: border-box;
    max-width: calc(100% - 2rem);
    & ~ [data-testid="input"] {
      padding-left: 1rem;
      visibility: hidden;
    }
  }
  ${({ disabled }) => {
    return (disabled &&
        (0, styled_components_1.css) `
        [data-testid="input-icon-right"],
        [data-testid="icon-value"] {
          cursor: default;
        }
      `);
}}
`;
exports.StyledValue = styled_components_1.default.span `
  border-radius: 50%;
`;
exports.StyledDropdownPopup = (0, styled_components_1.default)(main_2.Popup) `
  box-sizing: border-box;
  margin: 0.5rem 0 0 0;
  border-radius: 0.5rem;
  overflow: hidden;
  z-index: 1;
  ${(_a) => {
    var { theme, relatedRef } = _a, props = __rest(_a, ["theme", "relatedRef"]);
    const { current } = relatedRef;
    const { width } = (current === null || current === void 0 ? void 0 : current.getBoundingClientRect()) || {};
    return (0, styled_components_1.css) `
      box-shadow: 0px 2px 8px ${theme.textColor};
      background-color: ${theme.bgColor};
      color: ${theme.textColor};
      ${width && `width: ${width}px`}
    `;
}}
`;
exports.StyledDatalist = styled_components_1.default.ul.withConfig({
    shouldForwardProp: (prop) => !["maxHeight"].includes(prop),
}) `
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  margin: 0;
  ${({ maxHeight }) => (0, styled_components_1.css) `
    overflow: auto;
    max-height: ${maxHeight};
  `}
`;
exports.StyledOption = styled_components_1.default.li.withConfig({
    shouldForwardProp: (prop) => !["selected", "value"].includes(prop),
}) `
  font-size: 1rem;
  cursor: pointer;
  line-height: 1.5;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  [data-testid="option-label"] {
    flex: 1;
  }
  [data-testid="option-checkbox"] {
    align-self: center;
    flex: none;
  }
  ${({ theme, selected }) => {
    return (0, styled_components_1.css) `
      ${selected && `background-color: ${(0, polished_1.darken)(0.2, theme.bgColor)};`}
      &:not(:last-child) {
        border-bottom: 0.03rem solid
          ${(0, variants_1.variantTextColor)({ theme, variant: "disabled" })};
      }
      &:hover {
        background-color: ${(0, polished_1.darken)(0.1, theme.bgColor)};
      }
    `;
}}
`;
//# sourceMappingURL=styled.js.map